/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function ($, Drupal, window, document) {

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.essent = {
    attach: function (context, settings) {
      if (context !== document || !$('.video-modal').length) {
        return;
      }

      calculateModalDisplayParam();

      $(window).on('resize.calculateDisplayParam', function () {
        calculateModalDisplayParam();
      });

      function calculateModalDisplayParam() {
        $('.video-modal').each(function () {
          // Remove the display url segment to recalculate correct view mode.
          let paragraphId = $(this).attr('id');
          let urlParts = $(this).attr('href').split("/")
          urlParts.pop()
          let url = urlParts.join("/");

          let width = window.innerWidth;
          if (width >= 1024) {
            url = url + '/desktop_video';
          }
          else if (width < 1024 && width >= 768) {
            url = url + '/tablet_video';
          }
          else if (width < 768) {
            url = url + '/mobile_video';
          }

          $(this).attr('href', url);

          var selector = '#' + paragraphId;
          for (var index in Drupal.ajax.instances) {
            var ajaxInstance = Drupal.ajax.instances[index];
            if (ajaxInstance && (ajaxInstance.selector == selector)) {
              Drupal.ajax.instances[index].options.url = url.replace('nojs', 'ajax') + '?_wrapper_format=drupal_modal';
            }
          }
        });
      }
    }
  };

} (jQuery, Drupal, window, document));
